import {
  IconBrandInstagram,
  IconBrandFacebook,
  IconBrandX,
  IconBrandTiktok,
  IconBrandYoutube,
  IconBrandLinkedin,
  IconBrandPinterest,
  IconBrandBehance,
  IconBrandVimeo,
  IconWorld,
} from '../icons';
import { createElement } from 'react';
import imdbIcon from '../assets/imdb.png';
import modelsComIcon from '../assets/modelscom.png';

const createImageIcon = (src, alt, widthScale = 1, heightScale = 1) => {
  const ImageIcon = ({ size = 16, style, ...props }) => {
    const scaledWidth = Math.round(size * widthScale);
    const scaledHeight = Math.round(size * heightScale);

    return createElement('img', {
      src,
      alt,
      width: scaledWidth,
      height: scaledHeight,
      'data-social-image-icon': 'true',
      style: { display: 'block', objectFit: 'contain', ...style },
      ...props,
    });
  };

  return ImageIcon;
};

const IconModelsCom = createImageIcon(modelsComIcon, 'Models.com', 2.75, 1);
const IconImdb = createImageIcon(imdbIcon, 'IMDB', 1.7875, 1);

export const socialTypes = [
    {
        name: 'Instagram',
        code: 'Instagram',
        getUrl: (username) => `https://www.instagram.com/${username}`,
        getIcon: () => IconBrandInstagram,
        urlPrefix: 'https://www.instagram.com/',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/?/i,
        extractUsername: (url) => {
            // Remove protocol and domain
            let cleaned = url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/?/i, '');
            // Handle stories/highlights paths
            if (cleaned.startsWith('stories/')) {
                cleaned = cleaned.split('/')[1] || '';
            }
            return cleaned;
        },
    },
    {
        name: 'Facebook',
        code: 'Facebook',
        getUrl: (username) => `https://www.facebook.com/${username}`,
        getIcon: () => IconBrandFacebook,
        urlPrefix: 'https://www.facebook.com/',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?facebook\.com\/?/i,
        extractUsername: (url) => {
            return url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?facebook\.com\/?/i, '');
        },
    },
    {
        name: 'X / Twitter',
        code: 'Twitter',
        getUrl: (username) => `https://www.twitter.com/${username}`,
        getIcon: () => IconBrandX,
        urlPrefix: 'https://www.twitter.com/',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?(?:twitter\.com|x\.com)\/?/i,
        extractUsername: (url) => {
            return url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?(?:twitter\.com|x\.com)\/?/i, '');
        },
    },
    {
        name: 'Models.com',
        code: 'ModelsCom',
        getUrl: (username) => `https://www.models.com/${username}`,
        getIcon: () => IconModelsCom,
        urlPrefix: 'https://www.models.com/',
        regex: /^(?:http:\/\/|https:\/\/)?(?:www\.)?models\.com\/?/i,
        extractUsername: (url) => {
            // Keep models/ in the saved value (e.g. models/nomemodella)
            return url.replace(/^(?:http:\/\/|https:\/\/)?(?:www\.)?models\.com\/?/i, '');
        },
    },
    {
        name: 'TikTok',
        code: 'TikTok',
        getUrl: (username) => `https://www.tiktok.com/@${username}`,
        getIcon: () => IconBrandTiktok,
        urlPrefix: 'https://www.tiktok.com/@',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?tiktok\.com\/?/i,
        extractUsername: (url) => {
            let cleaned = url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?tiktok\.com\/?/i, '');
            // Remove @ prefix if present
            if (cleaned.startsWith('@')) {
                cleaned = cleaned.substring(1);
            }
            return cleaned;
        },
    },
    {
        name: 'YouTube',
        code: 'YouTube',
        getUrl: (username) => `https://www.youtube.com/channel/${username}`,
        getIcon: () => IconBrandYoutube,
        urlPrefix: 'https://www.youtube.com/channel/',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?youtube\.com\/?/i,
        extractUsername: (url) => {
            let cleaned = url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?youtube\.com\/?/i, '');
            // Handle different YouTube URL patterns
            const parts = cleaned.split('/');
            if (parts[0] === 'channel' || parts[0] === 'user' || parts[0] === 'u' || parts[0] === 'c') {
                return parts[1] || '';
            }
            return cleaned;
        },
    },
    {
        name: 'IMDB',
        code: 'IMDB',
        getUrl: (username) => `https://www.imdb.com/${username}`,
        getIcon: () => IconImdb,
        urlPrefix: 'https://www.imdb.com/',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?imdb\.com\/?/i,
        extractUsername: (url) => {
            // Keep full path after imdb.com/ (e.g. name/nm123456)
            return url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?imdb\.com\/?/i, '');
        },
    },
    {
        name: 'LinkedIn',
        code: 'LinkedIn',
        getUrl: (username) => `https://www.linkedin.com/in/${username}`,
        getIcon: () => IconBrandLinkedin,
        urlPrefix: 'https://www.linkedin.com/in/',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?linkedin\.com\/?/i,
        extractUsername: (url) => {
            let cleaned = url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?linkedin\.com\/?/i, '');
            // Remove 'in/' prefix if present
            if (cleaned.startsWith('in/')) {
                cleaned = cleaned.substring(3);
            }
            return cleaned;
        },
    },
    {
        name: 'Pinterest',
        code: 'Pinterest',
        getUrl: (username) => `https://www.pinterest.com/${username}`,
        getIcon: () => IconBrandPinterest,
        urlPrefix: 'https://www.pinterest.com/',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?pinterest\.(?:...)\/?/i,
        extractUsername: (url) => {
            return url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?pinterest\.(?:...)\/?/i, '');
        },
    },
    {
        name: 'Behance',
        code: 'Behance',
        getUrl: (username) => `https://www.behance.net/${username}`,
        getIcon: () => IconBrandBehance,
        urlPrefix: 'https://www.behance.net/',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?behance\.net\/?/i,
        extractUsername: (url) => {
            return url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?behance\.net\/?/i, '');
        },
    },
    {
        name: 'Vimeo',
        code: 'Vimeo',
        getUrl: (username) => `https://vimeo.com/${username}`,
        getIcon: () => IconBrandVimeo,
        urlPrefix: 'https://vimeo.com/',
        regex: /(?:(?:http|https):\/\/)?(?:www\.)?vimeo\.com\/?/i,
        extractUsername: (url) => {
            return url.replace(/(?:(?:http|https):\/\/)?(?:www\.)?vimeo\.com\/?/i, '');
        },
    },
    {
        name: 'Website',
        code: 'Personal',
        getUrl: (username) => `${username}`,
        getIcon: () => IconWorld,
        urlPrefix: '',
        regex: null,
        extractUsername: (url) => url,
    }
];

/**
 * Get the social media type by code
 */
export const getSocialByCode = (code) => {
  return socialTypes.find(s => s.code === code);
};

/**
 * Get the social media type by name
 */
export const getSocialByName = (name) => {
  return socialTypes.find(s => s.name === name);
};

/**
 * Complete URL with the social media base URL
 */
const completeURL = (social, username) => {
  if (!social) {
    return username;
  }
  return social.getUrl(username);
};

/**
 * Remove everything after the first forward slash
 */
const removeAfterFWDSlash = input => {
  if (input.split("/").length >= 2) {
    return input.split("/")[0];
  }
  return input;
};

/**
 * Remove everything after the question mark (query strings)
 */
const removeAfterQuestionMark = input => {
  if (input.split("?").length >= 2) {
    return input.split("?")[0];
  }
  return input;
};

/**
 * Remove @ prefix from username
 */
const trimAt = input => {
  return input.includes("@") ? input.substring(1) : input;
};

/**
 * Check if input is a website URL
 */
const isWebsite = input => {
  if (input && input.length > 0) {
    return input.includes("http") || input.includes("www");
  }
  return false;
};

/**
 * Determine the social media platform from a URL and extract the username
 * @param {string} _input - The URL or username to parse
 * @returns {Object} - { social: string (code), input: string (cleaned username) }
 */
const determineSocialMedia = (_input) => {
  if (!_input || typeof _input !== 'string') {
    return { social: "", input: _input || "" };
  }

  let cleanedInput = _input.trim();
  let detectedSocial = "";

  // Try to match against each social media platform
  for (const social of socialTypes) {
    if (social.regex && cleanedInput.match(social.regex)) {
      detectedSocial = social.code;
      cleanedInput = social.extractUsername(cleanedInput);
      break;
    }
  }

  // Clean up the username
  cleanedInput = trimAt(cleanedInput);
  cleanedInput = removeAfterQuestionMark(cleanedInput);
  // Models.com and IMDB store full path (models/..., name/...), don't strip after slash
  if (detectedSocial !== 'ModelsCom' && detectedSocial !== 'IMDB') {
    cleanedInput = removeAfterFWDSlash(cleanedInput);
  }

  return { social: detectedSocial, input: cleanedInput };
};

/**
 * Extract username from a full URL for a specific social media platform
 * @param {string} url - The full URL to parse
 * @param {string} socialCode - The social media platform code
 * @returns {string} - The extracted username/account ID
 */
export const extractUsernameFromUrl = (url, socialCode) => {
  if (!url || typeof url !== 'string') {
    return '';
  }

  const social = getSocialByCode(socialCode);
  if (!social) {
    return url;
  }

  let cleanedUrl = url.trim();

  // If the social platform has a custom extractor, use it
  if (social.extractUsername && social.regex) {
    if (cleanedUrl.match(social.regex)) {
      cleanedUrl = social.extractUsername(cleanedUrl);
    }
  }

  // Clean up the result
  cleanedUrl = trimAt(cleanedUrl);
  cleanedUrl = removeAfterQuestionMark(cleanedUrl);
  // Models.com and IMDB store full path (models/..., name/...), don't strip after slash
  if (socialCode !== 'ModelsCom' && socialCode !== 'IMDB') {
    cleanedUrl = removeAfterFWDSlash(cleanedUrl);
  }

  return cleanedUrl;
};

/**
 * Get the URL prefix and suffix for a social media platform
 * Used for displaying the fixed part of the URL in the UI
 */
const getSplittedUrl = (social) => {
  const url = social.getUrl("SPLITTER");
  const splittedUrl = url.split("SPLITTER");
  return splittedUrl;
};

/**
 * Get the URL prefix for a social media platform
 */
export const getUrlPrefix = (socialCode) => {
  const social = getSocialByCode(socialCode);
  return social ? social.urlPrefix : '';
};

export {
  completeURL,
  removeAfterFWDSlash,
  removeAfterQuestionMark,
  trimAt,
  isWebsite,
  determineSocialMedia,
  getSplittedUrl
};
